import UploadFileIcon from '@mui/icons-material/UploadFile'
import { Alert, Box, Typography } from '@mui/material'
import { useDropzone } from 'react-dropzone'
import { toast } from 'react-toastify'

interface FileDropzoneProps {
  selectedFile: File | null
  onFileSelect: (file: File) => void
  disabled?: boolean
}

export const FileDropzone = ({ selectedFile, onFileSelect, disabled }: FileDropzoneProps) => {
  const handleDrop = (acceptedFiles: File[]) => {
    if (acceptedFiles.length > 0) {
      onFileSelect(acceptedFiles[0])
    }
  }

  const handleDropRejected = (rejectedFiles: any[]) => {
    if (rejectedFiles.length > 0) {
      toast.error('Invalid file format. Please upload a CSV file.')
    }
  }

  const { getRootProps, getInputProps, isDragActive } = useDropzone({
    onDrop: handleDrop,
    onDropRejected: handleDropRejected,
    accept: '.csv',
    multiple: false,
    disabled,
  })

  return (
    <Box>
      <Box
        {...getRootProps()}
        sx={{
          border: '2px dashed',
          borderColor: isDragActive ? 'primary.main' : 'grey.400',
          borderRadius: 2,
          p: 4,
          textAlign: 'center',
          cursor: disabled ? 'not-allowed' : 'pointer',
          backgroundColor: isDragActive ? 'action.hover' : 'background.paper',
          '&:hover': {
            backgroundColor: disabled ? 'background.paper' : 'action.hover',
          },
        }}>
        <input {...getInputProps()} />
        <UploadFileIcon sx={{ fontSize: 48, color: 'grey.500', mb: 2 }} />
        <Typography variant='body1' gutterBottom>
          {isDragActive
            ? 'Drop the CSV file here...'
            : 'Drag and drop a SmartPay CSV file here, or click to select'}
        </Typography>
        <Typography variant='caption' sx={{ color: 'error.main', fontWeight: 'bold' }}>
          Only .csv files are accepted
        </Typography>
      </Box>

      {selectedFile && (
        <Alert severity='info' sx={{ mt: 2 }}>
          <Typography variant='body2'>
            <strong>Selected file:</strong> {selectedFile.name}
          </Typography>
          <Typography variant='caption' display='block'>
            Size: {(selectedFile.size / 1024).toFixed(2)} KB
          </Typography>
        </Alert>
      )}
    </Box>
  )
}
